import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "container"]

  connect() {
    this._onKeydown = this._handleKeydown.bind(this)
    document.addEventListener("keydown", this._onKeydown)
    this._trapFocus()
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
    this._restoreFocus()
  }

  close() {
    const frame = this.element.closest("turbo-frame")
    if (frame) {
      frame.textContent = ""
    } else {
      this.element.remove()
    }
  }

  _handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  _trapFocus() {
    this._previousFocus = document.activeElement
    const input = this.containerTarget.querySelector(
      "input, select, textarea, button:not(.bottom-sheet__close)"
    )
    if (input) {
      input.focus()
    } else {
      this.containerTarget.focus()
    }
  }

  _restoreFocus() {
    if (this._previousFocus && this._previousFocus.focus) {
      this._previousFocus.focus()
    }
  }
}
